import './version';
export * from '@uifabric/utilities';
//# sourceMappingURL=Utilities.js.map